export default "__VITE_ASSET__2d2cc37b__"